import React from 'react';
import c from 'classnames';

import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

const ContactFooterMenu = ({ currentPage }) => {
  return (
    <Menu id="secondary-footer">
      {(items) => {
        return (
          <>
            {items.map((item) => {
              if (item) {
                const className = item.getIn(['link', 'options', 'attributes', 'class', 0]);
                const itemTitle = item.getIn(['link', 'title'], 'Untitled');
                const url = item.getIn(['link', 'url'], '');
                const active = item.getIn(['link', 'url']) === currentPage;
                const FooterSubMenuItemClassnames = c('FooterSubMenu__item', className, {
                  'FooterSubMenu__item--active': active,
                  'icon-before': className,
                });

                return (
                  <div
                    key={itemTitle}
                    className={FooterSubMenuItemClassnames}
                  >
                    <CoreLink
                      className="FooterSubMenu__item__link"
                      to={url}
                    >
                      <span className="FooterSubMenu__item__title">{itemTitle}</span>
                    </CoreLink>
                  </div>
                );
              }
            })}
          </>
        );
      }}
    </Menu>
  );
};

export default ContactFooterMenu;
